import * as ReactDOMClient from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import i18n from "./i18n/config";
import { I18nextProvider } from "react-i18next";
import { Suspense } from "react";
import { App } from "./App";
import { BrowserRouter } from "react-router-dom";
import { PWABadge } from "./PWABadge";
import { installAuth0LoginBackoutGuard } from "./auth/Auth0RedirectGuard";

// Must run at initial load so the listener is captured in Chrome's bfcache snapshot and fires
// when the user returns via "Back" from the Auth0 login page (otherwise: blank page / login loop).
installAuth0LoginBackoutGuard();

const container = document.getElementById("root")!;

const root = ReactDOMClient.createRoot(container);

root.render(
  <I18nextProvider i18n={i18n}>
    <Suspense
      fallback={i18n.t("common.loadingText", { defaultValue: "Laden..." })}
    >
      <BrowserRouter>
        <PWABadge />
        <App />
      </BrowserRouter>
    </Suspense>
  </I18nextProvider>,
);
